import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { API } from '@/constants/bluemonk';

export const ApprovalModal = ({ open, onOpenChange, item, actor, headers, onSuccess }) => {
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);

  const handleApprove = async () => {
    if (!actor) {
      toast.error('Please select your identity first');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${API}/deliverables/${item.id}/approve`, {
        actor,
        note
      }, { headers });

      toast.success('Deliverable approved!');
      onSuccess();
      setNote('');
    } catch (error) {
      console.error('Approval error:', error);
      toast.error('Failed to approve. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!item) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md bg-white">
        <DialogHeader>
          <DialogTitle>Approve Deliverable</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 mt-4">
          <div className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="text-sm text-amber-800 font-medium">
              This approval is recorded permanently and cannot be undone.
            </p>
          </div>

          <div>
            <p className="font-medium text-slate-900">{item.title}</p>
            {item.description && (
              <p className="text-sm text-slate-600 mt-1">{item.description}</p>
            )}
          </div>

          <div>
            <Label>Note (optional)</Label>
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Add any feedback..."
              rows={2}
              className="mt-1"
            />
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button 
              onClick={handleApprove} 
              disabled={loading}
              className="bg-green-600 hover:bg-green-700"
            >
              {loading ? 'Approving...' : 'Confirm Approval'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
